import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-raise",
  "use": "icon-raise-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-raise\"><path d=\"M768 384L512 128 256 384h192v512h128V384z\" p-id=\"27537\" fill=\"#d81e06\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol